import {Injectable} from '@angular/core';
import {TokenService} from '../modules/common/services/token.service';
import {CountryType} from '../modules/common/enums/enums';
import {Environment} from "../environment/environment";

@Injectable()
export class AppConfig {

  static readonly PRIMARY_COLOR: string = '#133c64';
  static readonly SECONDARY_COLOR: string = '#faa61a';
  readonly MAX_ROLES: number =  5;
  readonly BUILDING_DETAILS_ISSUES_SIZE: number = 10;
  readonly DOCUMENT_LABEL_MAX_LENGTH: number = 100;
  readonly IOS_APP_LINK: string = '';
  readonly PAYMENT_MAX_USERS: number = 10;
  readonly PAYMENT_MAX_UNITS: number = 500;
  readonly ISSUE_DETAILS_EDIT_POPUP_SHOW_QUERY_PARAM: string = 'edit';
  readonly ISSUE_DETAILS_CREATE_JOB_QUERY_PARAM: string = 'createJob';
  readonly DEMO_SUBCRIPTION_NAVBAR_HEIGHT: number = 44;
  readonly STRUCTURE_ELEMENT_TYPES: string[] =
    ['BasicElementGroup', 'BasicElement', 'SpecificElementGroup', 'SpecificElement', 'ConformityElementGroup', 'ConformityElement'];
  readonly BUILDING_DASHBOARD_PLACEHOLDER_URL: string = 'assets/images/building-dashboard-placeholder.svg';
  readonly BUILDING_PLACEHOLDER_URL: string = 'assets/images/building-placeholder.svg';
  readonly SITE_PLACEHOLDER_URL: string = 'assets/images/site-placeholder.svg';
  readonly PDF_ICON_URL: string = 'assets/images/file-extensions/pdf.png';
  readonly DEFAULT_AVATAR_URL: string = 'assets/images/avatar_placeholder.png';
  readonly IMAGE_PLACEHOLDER_URL: string = 'assets/images/placeholder.png';
  readonly FAVOURITE_ICON_PATH: string = 'assets/images/favourites/favourite.svg';

  constructor(
      private readonly tokenService: TokenService,
      private readonly environment: Environment
  ) {
  }

  public get TAB_NAME() {
    return `Building_${this.environment.environmentName}`;
  }

  public get RESIDENZ_MANAGER_TAB_NAME() {
    return `ResidenzManager_${this.environment.environmentName}`;
  }


  readonly MESSAGES_REQUEST_INTERVAL: number = 30_000;
  readonly CHECKLIST_MAX_DEPTH: number = 2;
  readonly SYSTEM_NOTIFICATION_INTERVAL: number = 30_000;

  readonly INSPECTION_EXECUTORS_COLORS_LIST: any[] = [
    {primary: '#1196fa', secondary: '#1196fa'},
    {primary: '#4780df', secondary: '#4780df'},
    {primary: '#453890', secondary: '#453890'},
    {primary: '#e4c225', secondary: '#e4c225'},
    {primary: '#a5e80b', secondary: '#a5e80b'},
    {primary: '#178372', secondary: '#178372'},
    {primary: '#da2ee2', secondary: '#da2ee2'},
    {primary: '#345663', secondary: '#345663'},
    {primary: '#a26400', secondary: '#a26400'},
    {primary: '#a76485', secondary: '#a76485'},
    {primary: '#6a420b', secondary: '#6a420b'},
    {primary: '#ec4396', secondary: '#ec4396'},
    {primary: '#c95e72', secondary: '#c95e72'},
    {primary: '#a2a7c7', secondary: '#a2a7c7'},
    {primary: '#ff511f', secondary: '#ff511f'},
    {primary: '#239e22', secondary: '#239e22'},
    {primary: '#0e3985', secondary: '#0e3985'},
    {primary: '#d32704', secondary: '#d32704'},
  ];

  readonly INSPECTION_STATUS_COLOR_LIST =
      {
        Planned: "#6598E0",
        InProgress: "#646464",
        Completed: "#28A745",
        Cancelled: "#BBBBBB"
      }
  public TEAM_PLACEHOLDER = 'assets/images/avatar_placeholder.png';

  public get LOCALE(): string {
    return this.tokenService.getCulture();
  }

  public get DATE_FORMAT(): string {
    const country = this.tokenService.getCountry();
    return [CountryType.US.toString(), CountryType.CA.toString()].includes(country) ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
  }

  public get LONG_DATE_FORMAT(): string {
    const country = this.tokenService.getCountry();
    return [CountryType.US.toString(), CountryType.CA.toString()].includes(country) ? 'MMMM d y' : 'd MMMM y';
  }

  public get TIME_FORMAT(): string {
    const language = this.tokenService.getCulture();
    return language.startsWith('en') ? 'h:mm a' : 'H:mm';
  }

  public get DATE_TIME_FORMAT(): string {
    return `${this.DATE_FORMAT}, ${this.TIME_FORMAT}`;
  }
  
  public get LONG_DATE_TIME_FORMAT(): string {
    return `${this.LONG_DATE_FORMAT}, ${this.TIME_FORMAT}`;
  }
  
  

  public get MOMENT_DATE_FORMAT(): string {
    return this.DATE_FORMAT.toUpperCase();
  }

  public get MOMENT_DATE_TIME_FORMAT(): string {
    const [dateAndHour, minutes] = this.DATE_TIME_FORMAT.split(':');
    return [dateAndHour.toUpperCase(), minutes].join(':');
  }

  public get MAINTENANCE_ORGANIZER_TAB_NAME() {
    return `MaintenanceOrganizer_${this.environment.environmentName}`;
  }
}
